export function prettyDateInterval(fromDateString, toDateString) {
  const fromDateParts = fromDateString.split("-");
  const relativeMonths = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];
  const months = [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь",
  ];
  const fromYear = fromDateParts[0];
  const fromMonthIndex = parseInt(fromDateParts[1], 10) - 1;
  const fromDatePretty = `${relativeMonths[fromMonthIndex]} ${fromYear}`;

  if (toDateString == null) {
    return `c ${fromDatePretty} по настоящее время`;
  }
  const toDateParts = toDateString.split("-");

  const toYear = toDateParts[0];
  const toMonthIndex = parseInt(toDateParts[1], 10) - 1;

  return `c ${fromDatePretty} по ${months[toMonthIndex]} ${toYear}`;
}

export function getDateInterval(fromDateString, toDateString) {
  const fromDateParts = fromDateString.split("-");
  const fromYear = parseInt(fromDateParts[0], 10);
  const fromMonthIndex = parseInt(fromDateParts[1], 10) - 1;

  let toYear, toMonthIndex;

  if (toDateString == null) {
    const currentDate = new Date();
    toYear = currentDate.getFullYear();
    toMonthIndex = currentDate.getMonth();
  } else {
    const toDateParts = toDateString.split("-");
    toYear = parseInt(toDateParts[0], 10);
    toMonthIndex = parseInt(toDateParts[1], 10) - 1;
  }

  let totalMonths =
    (toYear - fromYear) * 12 + (toMonthIndex - fromMonthIndex) + 1;

  const months = [
    "месяц",
    "месяца",
    "месяца",
    "месяца",
    "месяцев",
    "месяцев",
    "месяцев",
    "месяцев",
    "месяцев",
    "месяцев",
    "месяцев",
    "месяцев",
  ];

  if (totalMonths === 0) {
    return "менее месяца";
  }
  if (totalMonths < 12) {
    return `${totalMonths} ${months[totalMonths - 1]}`;
  }

  const years = [
    "год",
    "года",
    "года",
    "года",
    "года",
    "лет",
    "лет",
    "лет",
    "лет",
    "лет",
    "лет",
  ];

  const totalYears = Math.floor(totalMonths / 12);
  const remainingMonths = totalMonths % 12;

  if (remainingMonths === 0) {
    return `${totalYears} ${years[totalYears]}`;
  }

  return `${totalYears} ${years[totalYears - 1]} и ${remainingMonths} ${months[remainingMonths - 1]}`;
}

export function formatDate(timestamp) {
  const date = new Date(timestamp * 1000);
  console.log(`DATE: ${date}`);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}
